/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Meeting_WaitingInputs */

const th_meeting_waiting = /** @type {(inputs: Meeting_WaitingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`กำลังรอ ${i?.name} เปิดเสียงเพื่อฟัง`)
};

const en_meeting_waiting = /** @type {(inputs: Meeting_WaitingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Waiting for ${i?.name}. Turn sound on to hear them.`)
};

const ja_meeting_waiting = /** @type {(inputs: Meeting_WaitingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} さんを待っています。音声を有効にすると聞こえます。`)
};

const zh_meeting_waiting = /** @type {(inputs: Meeting_WaitingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`正在等待 ${i?.name}。取消静音即可听到。`)
};

const es_meeting_waiting = /** @type {(inputs: Meeting_WaitingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Esperando a ${i?.name}. Activa el sonido para oírle.`)
};

const pt_meeting_waiting = /** @type {(inputs: Meeting_WaitingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aguardando ${i?.name}. Ative o som para ouvir.`)
};

const id_meeting_waiting = /** @type {(inputs: Meeting_WaitingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Menunggu ${i?.name}. Nyalakan suara untuk mendengar.`)
};

const fr_meeting_waiting = /** @type {(inputs: Meeting_WaitingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`En attente de ${i?.name}. Activez le son pour l’entendre.`)
};

const tl_meeting_waiting = /** @type {(inputs: Meeting_WaitingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hinihintay si ${i?.name}. I-unmute para makinig.`)
};

const vi_meeting_waiting = /** @type {(inputs: Meeting_WaitingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đang đợi ${i?.name}. Bật tiếng để nghe.`)
};

const ko_meeting_waiting = /** @type {(inputs: Meeting_WaitingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}님을 기다리는 중입니다. 소리를 들으려면 음소거를 해제하세요.`)
};

const de_meeting_waiting = /** @type {(inputs: Meeting_WaitingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Warte auf ${i?.name}. Schalte den Ton ein, um zu hören.`)
};

const ru_meeting_waiting = /** @type {(inputs: Meeting_WaitingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ждём ${i?.name}. Включите звук, чтобы слышать.`)
};

const tr_meeting_waiting = /** @type {(inputs: Meeting_WaitingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} bekleniyor. Duymak için sesi açın.`)
};

const it_meeting_waiting = /** @type {(inputs: Meeting_WaitingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`In attesa di ${i?.name}. Riattiva l'audio per sentire.`)
};

const pl_meeting_waiting = /** @type {(inputs: Meeting_WaitingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Czekamy na ${i?.name}. Wyłącz wyciszenie, aby słyszeć.`)
};

const uk_meeting_waiting = /** @type {(inputs: Meeting_WaitingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Чекаємо на ${i?.name}. Увімкніть звук, щоб чути.`)
};

const hi_meeting_waiting = /** @type {(inputs: Meeting_WaitingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} की प्रतीक्षा है। सुनने के लिए ध्वनि चालू करें।`)
};

const ar_meeting_waiting = /** @type {(inputs: Meeting_WaitingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`بانتظار ${i?.name}. ألغِ الكتم لتسمع.`)
};

const ms_meeting_waiting = /** @type {(inputs: Meeting_WaitingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Menunggu ${i?.name}. Nyahsenyap untuk mendengar.`)
};

const bn_meeting_waiting = /** @type {(inputs: Meeting_WaitingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}-এর অপেক্ষায়। শুনতে শব্দ চালু করুন।`)
};

const zh_tw2_meeting_waiting = /** @type {(inputs: Meeting_WaitingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`正在等待 ${i?.name}。取消靜音即可聽見。`)
};

const zh_hk2_meeting_waiting = /** @type {(inputs: Meeting_WaitingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`正在等待 ${i?.name}。取消靜音即可聽見。`)
};

const ur_meeting_waiting = /** @type {(inputs: Meeting_WaitingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} کا انتظار ہے۔ سننے کے لیے آواز چالو کریں۔`)
};

const fa_meeting_waiting = /** @type {(inputs: Meeting_WaitingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`در انتظار ${i?.name}. برای شنیدن صدا را روشن کنید.`)
};

const sw_meeting_waiting = /** @type {(inputs: Meeting_WaitingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Inamsubiri ${i?.name}. Washa sauti ili kusikia.`)
};

const nl_meeting_waiting = /** @type {(inputs: Meeting_WaitingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Wachten op ${i?.name}. Zet het geluid aan om mee te luisteren.`)
};

/**
* | output |
* | --- |
* | "Waiting for {name}. Turn sound on to hear them." |
*
* @param {Meeting_WaitingInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const meeting_waiting = /** @type {((inputs: Meeting_WaitingInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_WaitingInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_meeting_waiting(inputs)
	if (locale === "ja") return ja_meeting_waiting(inputs)
	if (locale === "zh") return zh_meeting_waiting(inputs)
	if (locale === "es") return es_meeting_waiting(inputs)
	if (locale === "pt") return pt_meeting_waiting(inputs)
	if (locale === "id") return id_meeting_waiting(inputs)
	if (locale === "fr") return fr_meeting_waiting(inputs)
	if (locale === "tl") return tl_meeting_waiting(inputs)
	if (locale === "vi") return vi_meeting_waiting(inputs)
	if (locale === "ko") return ko_meeting_waiting(inputs)
	if (locale === "de") return de_meeting_waiting(inputs)
	if (locale === "ru") return ru_meeting_waiting(inputs)
	if (locale === "tr") return tr_meeting_waiting(inputs)
	if (locale === "it") return it_meeting_waiting(inputs)
	if (locale === "pl") return pl_meeting_waiting(inputs)
	if (locale === "uk") return uk_meeting_waiting(inputs)
	if (locale === "hi") return hi_meeting_waiting(inputs)
	if (locale === "ar") return ar_meeting_waiting(inputs)
	if (locale === "ms") return ms_meeting_waiting(inputs)
	if (locale === "bn") return bn_meeting_waiting(inputs)
	if (locale === "zh-TW") return zh_tw2_meeting_waiting(inputs)
	if (locale === "zh-HK") return zh_hk2_meeting_waiting(inputs)
	if (locale === "ur") return ur_meeting_waiting(inputs)
	if (locale === "fa") return fa_meeting_waiting(inputs)
	if (locale === "sw") return sw_meeting_waiting(inputs)
	if (locale === "nl") return nl_meeting_waiting(inputs)
	return en_meeting_waiting(inputs)
});